import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Tooltip } from '@material-ui/core';

import { IconSettings } from 'src/assets/icons/IconSettings';
import { CustomTypography, TYPOGRAPHY_VARIANT } from 'src/components/CustomTypography';
import { useStyles } from './useStyles';

export const BrandVoiceSettingsTitle = ({
  className,
  title,
  showSettings,
  settingsTooltipText,
  onSettingsClick,
  large,
}) => {
  const styles = useStyles();

  return (
    <div className={cx(styles.root, className)}>
      <CustomTypography variant={large ? TYPOGRAPHY_VARIANT.medium14 : TYPOGRAPHY_VARIANT.medium12}>
        {title}
      </CustomTypography>

      {showSettings && (
        <Tooltip title={settingsTooltipText}>
          <IconSettings
            className={styles.settingsIcon}
            onClick={onSettingsClick}
          />
        </Tooltip>
      )}
    </div>
  );
};

BrandVoiceSettingsTitle.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  showSettings: PropTypes.bool,
  settingsTooltipText: PropTypes.string,
  onSettingsClick: PropTypes.func,
  large: PropTypes.bool,
};
BrandVoiceSettingsTitle.defaultProps = {
  className: null,
  title: null,
  showSettings: false,
  settingsTooltipText: ' ',
  onSettingsClick: null,
  large: false,
};
